import { jwtDecode } from 'jwt-decode';

const isValidAccessToken = (accesToken) => {
   if (!accesToken || accesToken === 'undefined' || accesToken === null || accesToken === '') {
      return false;
   }

   let tokenDecoded = jwtDecode(accesToken);
   let expiredDate = new Date(tokenDecoded.exp * 1000);
   let validationDate = new Date();

   validationDate.setMinutes(validationDate.getMinutes() + 5);

   return validationDate.getTime() < expiredDate.getTime();

};

const getTokenData = (token) => {
   if (isValidAccessToken(token)) {
      const data = jwtDecode(token);
      return {
         token,
         user: data.sub,
         roles: data.roles || [],
      };
   }
   return null;
};

const hasPermission = (auth, role) => {
   return auth.roles.map(r => r.authority).some(authority => authority === role);
};
export default {
   isValidAccessToken,
   getTokenData,
   hasPermission
};
